import { auctionUser } from '@/helpers/constant';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuctionService } from '@services/auction/auction.service';
import { InventoryService } from '@services/inventory/inventory.service';
import { SharedService } from '@services/shared/shared.service';
import { UserService } from '@services/user/user.service';
import { environment } from 'environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-purchase-details',
  templateUrl: './purchase-details.component.html',
  styleUrls: ['./purchase-details.component.scss'],
})
export class PurchaseDetailsComponent implements OnInit {
  env: string = environment.forntend_url;
  paymentId: string = '';
  loading: boolean = false;
  laddaLoading: boolean = false;
  paymentInfo: object[] = [];
  lang: 'ar' | 'en' | string = 'en';
  paymentDocs: object[] = [];
  laddaSellButton: boolean = false;
  invoice: object[] = [];
  productId: string = '';
  invoiceAvailable: boolean = false;
  invoiceUrl: string = '';
  uploadBtnStatus: boolean = true;
  laddaBtnStates: boolean[] = [];
  laddaBtnStatesInModal: boolean[] = [];
  enableReserve: boolean = false;
  fullPaymentStatus: boolean = false;
  reserveStatus: 'Reserved' | 'Not Reserved';
  laddaReserveBtn: boolean = false;
  showSellOption: boolean = false;
  whyReject: string = '';
  rejectedDocId: string = '';
  rejectedDocName: string = '';
  rejectedDocIndex: number = -1;
  rejectLaddaBtn: boolean = false;
  employeeList: object[] = [];
  employeeEmail: string = '';
  employeePhone: string = '';
  employeeName: string = '';

  modalRef?: BsModalRef;
  modalConfig = {
    ignoreBackdropClick: true,
    class: 'modal-lg',
  };

  globalDocsObj = {
    'Payment Receipts': {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
    Invoice: {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
    'Sales Order': {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
    'Approved Delivery Note': {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
    'Transferred ISTIMARA ( Registration card )': {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
  };

  constructor(
    private route: ActivatedRoute,
    private inventoryService: InventoryService,
    private sharedService: SharedService,
    private auctionService: AuctionService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private userService: UserService
  ) {
    const paymentId = this.route.snapshot.paramMap.get('paymentId');

    if (paymentId) {
      this.paymentId = paymentId;
    }
  }

  ngOnInit(): void {
    this.getPaymentInfo();
  }

  getPaymentInfo() {
    this.loading = true;
    this.inventoryService.purchaseView(this.paymentId).subscribe((res) => {
      if (res['success']) {
        this.sharedService.modifiedData([res['data']]);
        this.paymentInfo = res['data'];
        this.paymentDocs = res['data']['userPaymentDoc'];
        this.reserveStatus =
          res['data']['payment_order_type_status'] === true
            ? 'Reserved'
            : 'Not Reserved';

        this.loading = false;
        this.productId = res['data']['product_id'];
        this.getVehicleImage(res['data']);
        this.reserveAndFinanceStatus();
        this.showSellBtn();
      }
    });
  }

  viewDocument(docUrl: string) {
    window.open(docUrl, '_blank');
  }

  updatePaymentStatus(productId: string, status: string, vehicleId: string) {
    this.laddaSellButton = true;

    const payload = {
      approve: status,
      payment_id: this.paymentId,
    };

    let auctionToken = JSON.parse(localStorage.getItem('auctionUser'));
    if (auctionToken) {
      this.checkVehicleStatus(vehicleId, productId, payload, 'sell');
    } else {
      this.auctionAuthCheck(vehicleId, productId, payload, 'sell');
    }
  }

  // auction user check and get token of the user.
  auctionAuthCheck(vehicleId, productId, payload, type) {
    this.auctionService.auctionAuthenticationCheck(auctionUser).subscribe(
      (res) => {
        if (res['success']) {
          localStorage.setItem('auctionUser', JSON.stringify(res));
          if (type === 'sell') {
            this.checkVehicleStatus(vehicleId, productId, payload, 'sell');
          } else {
            // As per discussion lock api also call during reserve.
            this.checkReserveVehicleStatus(
              vehicleId,
              productId,
              payload,
              'reserve'
            );
          }
        }
      },
      (error: HttpErrorResponse) => {
        this.toastr.error('Something went wrong!');
        this.loading = false;
      }
    );
  }

  // vehicle log status check and if success then update payment status check.
  checkVehicleStatus(vehicleId?: string, productId?, payload?, type = 'sell') {
    const params = {
      vehicle_id: vehicleId,
      is_sold: 1,
      is_reserved: 1,
    };
    this.VehicleStatusApiCall(params, vehicleId, productId, payload, type);
  }

  updateReserveStatus(productId: string, status: string, vehicleId: string) {
    this.laddaReserveBtn = true;

    const payload = {
      approve_order_type: status,
      payment_id: this.paymentId,
    };

    // this.inventoryService.vehicleReserveStatus(productId, payload).subscribe((res) => {
    //   if (res['success']) {
    //     this.reserveStatus === 'Reserved' ? this.reserveStatus = 'Not Reserved' : this.reserveStatus = 'Reserved'
    //     this.paymentInfo['payment_order_type_status'] = !this.paymentInfo['payment_order_type_status']
    //     this.toastr.success(res['message'])
    //   }
    //   this.laddaReserveBtn = false
    // });

    // As per discussion lock api also call during reserve.
    let auctionToken = JSON.parse(localStorage.getItem('auctionUser'));
    if (auctionToken) {
      this.checkReserveVehicleStatus(vehicleId, productId, payload, 'reserve'); // vehicle log api call.
    } else {
      this.auctionAuthCheck(vehicleId, productId, payload, 'reserve'); // If token not available in the local storage.
    }
  }

  checkReserveVehicleStatus(vehicleId, productId, payload, type) {
    var params = {
      vehicle_id: vehicleId,
      is_reserved: +payload.approve_order_type,
    };

    this.VehicleStatusApiCall(params, vehicleId, productId, payload, type);
  }

  VehicleStatusApiCall(formData: any, vehicleId, productId, payload, type) {
    this.auctionService.vehicleStatusCheck(formData).subscribe(
      (res: HttpResponse<any>) => {
        // || res.status === 200
        if (res.body['success'] && formData.is_sold) {
          this.auctionService
            .updatePaymentStatus(productId, payload)
            .subscribe((res) => {
              if (res['success']) {
                this.paymentInfo['buy_status'] = '2';
              }
              this.laddaSellButton = false;
            });
        }
        // As per discussion lock api also call during reserve.
        // || res.status === 200
        else if (res.body['success'] && !formData.is_sold) {
          this.inventoryService
            .vehicleReserveStatus(productId, payload)
            .subscribe((res) => {
              if (res['success']) {
                this.reserveStatus === 'Reserved'
                  ? (this.reserveStatus = 'Not Reserved')
                  : (this.reserveStatus = 'Reserved');
                this.paymentInfo['payment_order_type_status'] =
                  !this.paymentInfo['payment_order_type_status'];
                this.toastr.success(res['message']);
              }
              this.laddaReserveBtn = false;
            });
        } else {
          // if unsuccess or token expired then auth token api call.
          this.auctionAuthCheck(vehicleId, productId, payload, type);
        }
      },
      (error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.auctionAuthCheck(vehicleId, productId, payload, type);
        } else {
          this.toastr.error('Something went wrong!');
        }
        this.loading = false;
      }
    );
  }

  getVehicleImage(vehicleDetails: object) {
    let frontImg = '';
    let imgBaseUrl = '';

    if (vehicleDetails['type'] === '2') {
      imgBaseUrl = environment.auctionBaseUrl;
    } else {
      imgBaseUrl = environment.imgBaseUrl;
    }

    if (
      vehicleDetails?.['vehicle_images']?.['parts_images'] &&
      vehicleDetails['vehicle_images']['parts_images'].length
    ) {
      for (
        let i = 0;
        i < vehicleDetails['vehicle_images']['parts_images'].length;
        i++
      ) {
        if (
          vehicleDetails['vehicle_images']['parts_images'][i]?.['part_name'] ===
          'Front'
        ) {
          frontImg =
            imgBaseUrl +
            vehicleDetails['vehicle_images']['parts_images'][i]['image'];
          break;
        }
      }
    } else if (vehicleDetails?.['productImageUrl']?.[0]?.['presigned_url']) {
      frontImg = vehicleDetails['productImageUrl'][0]['presigned_url'];
    } else if (vehicleDetails?.['imageUrl']?.[0]?.['presigned_url']) {
      frontImg = vehicleDetails['imageUrl'][0]['presigned_url'];
    } else {
      frontImg = this.env + 'assets/img/car-placeholder.png';
    }

    vehicleDetails['frontImg'] = frontImg;
  }

  getBase64(blob: Blob) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  async getDocument(event: Event, docName: string) {
    const document = (event.target as HTMLInputElement).files[0];
    const base64: any = await this.getBase64(document);

    let base64WithOutType: string;

    if (document.type === 'image/jpeg') {
      base64WithOutType = base64.replace('data:image/jpeg;base64,', '');
    } else if (document.type === 'application/pdf') {
      base64WithOutType = base64.replace('data:application/pdf;base64,', '');
    }

    this.invoice.push({ image: base64WithOutType, name: docName });

    if (this.globalDocsObj[docName]) {
      this.globalDocsObj[docName]['enableUpload'] = true;
    }

    this.uploadBtnStatus = false;
  }

  uploadDocument(productId: string, docName: string, index: number) {
    this.laddaBtnStatesInModal[index] = true;
    const docToUpload: object[] = [];

    this.invoice.forEach((doc) => {
      if (doc['name'] === docName) {
        docToUpload.push(doc);
      }
    });

    if (!docToUpload.length) {
      this.laddaBtnStatesInModal[index] = false;
      return this.toastr.error('No Document found with this name: ' + docName);
    }

    const payload = {
      documents: docToUpload,
    };

    this.inventoryService.uploadPurchaseInvoice(productId, payload).subscribe(
      (res) => {
        if (res['success']) {
          this.laddaBtnStatesInModal[index] = false;
          this.toastr.success(res['message']);
          this.getPurchaseInvoice(productId);
        }

        this.laddaLoading = false;
      },
      (error) => {
        this.laddaLoading = false;
        console.error(error);
      }
    );
  }

  // HERE
  getPurchaseInvoice(productId: string, docToDelete?: string) {
    if (docToDelete) {
      this.globalDocsObj[docToDelete]['available'] = false;
      this.globalDocsObj[docToDelete]['enableUpload'] = false;
    }

    this.inventoryService.getPurchaseInvoice(productId).subscribe((res) => {
      res['data']['invoice_doc']?.forEach((doc) => {
        if (this.globalDocsObj[doc['document_name']]) {
          this.globalDocsObj[doc['document_name']]['available'] = true;
          this.globalDocsObj[doc['document_name']]['imageUrl'] =
            doc['imageUrl']['presigned_url'];
          this.globalDocsObj[doc['document_name']]['id'] = doc['doc_id'];
          this.globalDocsObj[doc['document_name']]['uploadTime'] =
            doc['created_at'];
        }
      });
    });
  }

  viewPurchaseInvoice(invoiceUrl: string) {
    window.open(invoiceUrl, '_blank');
  }

  deleteAfterSellDocs(
    productId: string,
    docId: string,
    docName: string,
    index: number
  ) {
    this.laddaBtnStatesInModal[index] = true;

    const payload = {
      product_invoice_id: docId,
    };

    this.inventoryService.deleteAfterSellDocs(productId, payload).subscribe(
      (res) => {
        if (res['success']) {
          this.laddaBtnStatesInModal[index] = false;
          this.toastr.success(res['message']);
          this.getPurchaseInvoice(productId, docName);
        }
      },
      (error) => {
        this.laddaBtnStatesInModal[index] = false;
        console.error(error);
      }
    );
  }

  userDocStatusUpdate(docId: string, status: string, laddaIndex: number) {
    let payload: object;

    if (status === '0') {
      this.rejectLaddaBtn = true;
      payload = {
        document_id: docId,
        document_status: status,
        notes: this.whyReject,
      };
    } else {
      payload = {
        document_id: docId,
        document_status: status,
      };
    }

    this.laddaBtnStates[laddaIndex] = true;

    this.inventoryService
      .userDocApproveReject(this.paymentId, payload)
      .subscribe((res) => {
        if (res['success']) {
          this.laddaBtnStates[laddaIndex] = false;
          this.rejectLaddaBtn = false;
          this.modalRef?.hide();
          this.paymentDocs[laddaIndex]['order_document_status'] =
            status === '1' ? true : false;
          this.showSellBtn();
          this.checkForReserveSlipApprove();
        }
      });
  }

  reserveAndFinanceStatus() {
    this.paymentDocs?.forEach((doc) => {
      if (doc['document_name'] === 'Reserve Slip') {
        doc['order_document_status'] === true
          ? (this.enableReserve = true)
          : (this.enableReserve = false);
      }

      if (
        doc['document_name'] === 'Payment Receipt' &&
        this.paymentInfo['payment_order_type_status'] &&
        doc['order_document_status']
      ) {
        this.fullPaymentStatus = true;
      }
    });
  }

  showSellBtn() {
    this.paymentDocs?.forEach((doc) => {
      if (doc['document_name'] === 'Payment Receipt / Finance Receipt') {
        if (
          doc['order_document_status'] &&
          this.paymentInfo['payment_order_type_status']
        ) {
          this.showSellOption = true;
        } else {
          this.showSellOption = false;
        }
      }
    });
  }

  checkForReserveSlipApprove() {
    this.paymentDocs.forEach((doc) => {
      if (doc['document_name'] === 'Reserve Slip') {
        doc['order_document_status'] === true
          ? (this.enableReserve = true)
          : (this.enableReserve = false);
      }
    });
  }

  openDocsUploadModal(template: TemplateRef<any>) {
    this.getPurchaseInvoice(this.productId);
    this.modalRef = this.modalService.show(template, this.modalConfig);
  }

  openRejectWhyModal(
    template: TemplateRef<any>,
    docId: string,
    status: string,
    index: number,
    docName: string
  ) {
    this.rejectedDocId = docId;
    this.rejectedDocName = docName;
    this.rejectedDocIndex = index;
    this.modalRef = this.modalService.show(template, this.modalConfig);
  }

  onSubmitReject() {
    if (!this.whyReject) {
      return this.toastr.error('Please provide reason');
    }

    this.userDocStatusUpdate(this.rejectedDocId, '0', this.rejectedDocIndex);
  }

  openPDIModal(template: TemplateRef<any>) {
    const payload = {
      user_type: 1,
    };

    this.userService.userList(payload).subscribe((res) => {
      if (res['success']) {
        this.employeeList = res['data'];
      }
    });
    this.modalRef = this.modalService.show(template, {
      ignoreBackdropClick: true,
    });
  }

  onOptionChanged(index: number) {
    if (!index) {
      this.employeePhone = '';
      return;
    }

    this.employeePhone = this.employeeList[index]['phone'];
    this.employeeEmail = this.employeeList[index]['email'];
    this.employeeName =
      this.employeeList[index]['first_name'] +
      ' ' +
      this.employeeList[index]['last_name'];
  }

  completeSell() {
    if (!this.employeePhone) {
      this.toastr.error('Please select an employee!');
      return;
    }

    this.laddaSellButton = true;

    this.updatePaymentStatus(
      this.productId,
      '1',
      this.paymentInfo['vehicle_id']
    );

    let message = `Keep ready ${this.paymentInfo['vehicle_name']}`;
    message =
      message +
      `\nVIN - ${this.paymentInfo?.['description_data']?.['VIN Number']} \nREG - ${this.paymentInfo?.['description_data']?.['Plate Number']}`;
    message =
      message +
      `\nfor delivery on ${new Date(
        this.paymentInfo?.['order_date']
      ).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })} to ${this.paymentInfo['first_name']} ${
        this.paymentInfo['last_name']
      }`;

    const payload = {
      phone_number: this.employeePhone,
      pdi_message: message,
    };

    this.userService.userPDI(payload).subscribe((res) => {
      if (res['success']) {
        this.toastr.success(`PDI Notified to ${this.employeeName}`);
        this.modalRef?.hide();
      }

      this.laddaSellButton = false;
    });
  }
}
